import React, { useState, useEffect } from "react";
import TextArea from "../../common/TextArea";
import InputTag from "../../common/InputTag";
import SelectBox from "../../common/SelectBox";
import TextField from "../../common/TextField";
import ExternalLinkField from "../../common/ExternalLinkField";
import { KEYWORD_SUGGESTIONS } from "../../../Constants/suggestions";
import { ReactComponent as PlusIcon } from "../../../assets/img/common/plus-icon.svg";
import { ACCEPT_IMAGE_FILES, EDITOR_LIMITS } from "../../../Constants";
import CropImageModal from "../../common/CropImgModal";
import handleCropImgChange from "../../../utils/handleCropImgChange";
import { ReactComponent as RemoveRowIcon } from "../../../assets/img/common/trash-red-icon.svg";
import { ReactComponent as ProfileEdtiIcon } from "../../../assets/img/common/profile-edit-icon.svg";
import FieldErrorMsg from "../../common/FieldErrorMsg";
import useResetForm from "../../../hooks/useResetForm";
import { categories } from "../../../data/dataCheckboxes";
import LexicalEditor from "../../common/LexicalEditor";
import { useDispatch, useSelector } from "react-redux";
import {
  selectGeneral,
  setShowFullscreenImage,
} from "../../../redux/slices/generalSlice";
import FullScreenImage from "../../common/FullscreenImage";

const Step1 = ({ formik, containerClass }) => {
  const [showProjectCropModal, setShowProjectCropModal] = useState(false);
  const [cropProjectImage, setCropProjectImage] = useState(
    formik?.values?.abstract || null
  );
  const [projectImg, setProjectImg] = useState(
    formik?.values?.abstract || null
  );
  const dispatch = useDispatch();
  const { showFullscreenImage } = useSelector(selectGeneral);

  const handleImageSelect = (e) => {
    handleCropImgChange(e, setProjectImg, setShowProjectCropModal);
  };
  useEffect(() => {
    if (formik?.values?.abstract && !cropProjectImage && !projectImg) {
      setCropProjectImage(formik?.values?.abstract);
      setProjectImg(formik?.values?.abstract);
    }
  }, [formik?.values?.abstract, cropProjectImage, projectImg]);
  useResetForm({
    onMount: () => {
      setProjectImg(null);
      setCropProjectImage(null);
    },
  });

  return (
    <div
      className={`w-full flex flex-col ${containerClass} transition-all duration-300`}
    >
      <section className="w-full flex flex-col-reverse md:flex-row justify-between mlg:h-[550px] gap-y-4 ">
        {/* project detail */}
        <div className="w-full mlg:w-[45%] flex flex-col h-full justify-between max-mlg:gap-y-6">
          <h3 className="text-2xl abel-font max-mlg:-mb-4 hidden mlg:block">
            Basic Info
          </h3>
          <TextField
            id={"title"}
            // onChange={formik.handleChange}
            value={formik.values.title}
            disabled={
              formik?.values?.visible || formik?.values?.nft_details?.address
            }
            title={"Project Title"}
            placeholder={"Write a short and accurate title of your project"}
            containerClass="w-full"
            inputClass="h-12"
            formik={formik}
            onBlur={formik.handleBlur}
            required
          />
          {/* ///// category ////// */}
          <SelectBox
            disabled={
              formik?.values?.visible || formik?.values?.nft_details?.address
            }
            id={"category"}
            options={categories.map((item) => ({
              value: item?.title,
              title: item?.title,
            }))}
            // onChange={formik.handleChange}
            value={formik.values.category}
            title={"Category"}
            placeholder={"Select a category related to your project"}
            containerClass="w-full"
            selectContainerClass="w-full h-12"
            formik={formik}
            onBlur={formik.handleBlur}
            required
          />
          {/* //////// keyword /////// */}
          <InputTag
            id={"keywords"}
            formik={formik}
            value={formik?.values?.keywords}
            title={"Keyword"}
            placeholder={"Add the most prominent keywords of your project"}
            suggestions={KEYWORD_SUGGESTIONS}
            required
          />
          <ExternalLinkField
            id={"links"}
            onChange={formik.handleChange}
            value={formik.values.links}
            title={"Project Link"}
            description={
              "Please provide external links to your projects (Personal web page, Github, Kaggle, Dribble, ...)"
            }
            placeholder={"https://yoursite.io"}
            containerClass="w-full"
            inputClass=""
            formik={formik}
            onBlur={formik.handleBlur}
          />
        </div>
        {/* project img */}
        <div className="w-full mlg:w-[55%] h-full mlg:ml-12 relative">
          <div
            id="abstract"
            className={`w-full h-full rounded-3xl bg-[#E1E0E3] flex flex-col justify-center items-center overflow-hidden ${
              formik?.touched?.abstract &&
              formik?.errors?.abstract &&
              "border-2 border-red-500"
            } `}
          >
            {cropProjectImage || formik.values.abstract ? (
              <div className="w-full h-full relative ">
                {!formik?.values?.visible && (
                  <>
                    <label
                      onClick={() => {
                        if (cropProjectImage || formik.values.abstract)
                          setShowProjectCropModal(true);
                      }}
                      className="w-9 h-9 p-1 flex justify-center items-center rounded-full bg-primary absolute right-3 top-3 cursor-pointer z-10"
                    >
                      <ProfileEdtiIcon />

                      <input
                        type="file"
                        className="hidden"
                        onChange={handleImageSelect}
                        accept={ACCEPT_IMAGE_FILES}
                        disabled={cropProjectImage || formik.values.abstract}
                      />
                    </label>

                    <button
                      className="w-9 h-9 flex justify-center items-center rounded-full absolute left-3 top-3 cursor-pointer z-10 bg-custom-gray-200"
                      onClick={() => {
                        setProjectImg(null);
                        setCropProjectImage(null);
                        formik?.setFieldValue("abstract", "");
                      }}
                    >
                      <RemoveRowIcon />
                    </button>
                  </>
                )}
                <img
                  onClick={() => dispatch(setShowFullscreenImage(true))}
                  src={formik.values.abstract || cropProjectImage}
                  alt="abstract"
                  className="w-full h-full object-cover transition-all duration-300 hover:scale-105 cursor-pointer"
                />
              </div>
            ) : (
              <div className="w-full mlg:h-full max-mlg:py-6 flex flex-col justify-center items-center">
                <label
                  onClick={() => {
                    if (cropProjectImage || formik.values.abstract)
                      setShowProjectCropModal(true);
                  }}
                  className="w-8 h-8 flex justify-center items-center rounded-full bg-white cursor-pointer"
                >
                  <PlusIcon />
                  <input
                    type="file"
                    className="hidden"
                    onChange={handleImageSelect}
                    accept={ACCEPT_IMAGE_FILES}
                  />
                </label>
                <span className=" text-lg font-medium mt-2 roboto-font">
                  Add Graphical Abstract
                </span>
                <p className="text-[#595959] w-11/12 mlg:w-8/12 text-center mt-2 mlg:mt-5 text-sm leading-5">
                  A graphical abstract (or visual abstract) is a graphical or
                  visual equivalent of a written abstract. Graphical abstracts
                  are a single image and are designed to help the reader to
                  quickly gain an overview on a scholarly paper, research
                  project, Diagram, etc .
                </p>
                <span className="text-[#3C2166] mt-7  text-sm ">
                  File types: JPG, PNG, GIF. Max size: 2 MB
                </span>
              </div>
            )}
          </div>
          <FieldErrorMsg formik={formik} id="abstract" />
        </div>
      </section>
      {/* project summary */}
      <LexicalEditor
        id={"summary"}
        onChange={(value) => {
          formik.setFieldValue("summary", value);
        }}
        value={formik.values.summary}
        title={"Project Summary (Problem statement, objectives, ...)"}
        placeholder={
          "Write a summary of research proposal includes definition, background, objectives, and methods of your research, etc."
        }
        containerClass="w-full mt-16"
        formik={formik}
        onBlur={formik.handleBlur}
        limit={EDITOR_LIMITS.summary}
        showImageBtn={true}
        required={true}
      />
      {showProjectCropModal && (
        <CropImageModal
          setShow={setShowProjectCropModal}
          show={showProjectCropModal}
          cropImage={cropProjectImage}
          setCropImage={setCropProjectImage}
          setImage={setProjectImg}
          image={projectImg}
          type="project"
          id="abstract"
          formik={formik}
        />
      )}
      {showFullscreenImage && (
        <FullScreenImage img={formik.values.abstract || cropProjectImage} />
      )}
    </div>
  );
};

export default Step1;